import React, { useEffect, useState } from 'react';

import { Auth } from '../../../../support';
import NoticeHighlighter from '../../../../shared/notice/NoticeHighlighter';

const AccountSuspendedHighlighter = (props) => {
  const [cliente, setCliente] = useState({});

  useEffect(() => {
    const data = Auth.getData();

    setCliente({
      ...data.cliente,
    });

    return () => {};
  }, []);

  if (cliente.status === 1 || cliente.status === 2) {
    return <></>;
  }

  const metadata = {
    variant: 'danger',
    nombre_comercial: cliente.nombre_comercial,
    notice:
      'Tu cuenta actualmente presenta un cargo vencido. Es importante generar el pago para que puedas acceder a tu cuenta. Para generar tu pago o cualquier aclaración, por favor comunicate via correo a facturacion@pactopia.mx',
  };
  return <NoticeHighlighter {...metadata} />;
};

export default AccountSuspendedHighlighter;
